var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styles from './input-option-illustration.module.less';
import classNames from 'classnames';
export const Illustration = ({ coloredBackground = false, hideMobile = true, size = 80, src, alt = '', className, }) => {
    const cssVariables = {
        '--illustration-url': `url(${src})`,
        '--illustration-size': `${size}px`,
    };
    return (React.createElement("div", { className: classNames(styles.illustration, { [styles.hideMobile]: hideMobile }, { [styles.coloredBackground]: coloredBackground }, className), style: cssVariables },
        React.createElement("img", { className: styles.placeholder, src: src, alt: alt, style: cssVariables })));
};
export const GroupOptionIllustration = (_a) => {
    var { className, coloredBackground } = _a, rest = __rest(_a, ["className", "coloredBackground"]);
    return (React.createElement(Illustration, Object.assign({ className: classNames(styles.groupOptionOffset, className), coloredBackground: coloredBackground !== null && coloredBackground !== void 0 ? coloredBackground : true }, rest)));
};
